import { z } from "zod";
import { surfaceEnvelope } from "./shared";

export const PulseProjectSchema = z.object({ project_name: z.string(), estimated_tokens: z.number(), conversation_count: z.number(), pct: z.number() }).passthrough();
export const PulseWeekSchema = z.object({ week_start: z.string(), estimated_tokens: z.number(), conversation_count: z.number() }).passthrough();
export const PulseSiteSchema = z.object({ site: z.string(), estimated_tokens: z.number(), pct: z.number() }).passthrough();

export const PulseSurfaceDataSchema = z.object({
  total_tokens: z.number(),
  tokens_this_week: z.number(),
  by_project: z.array(PulseProjectSchema).default([]),
  weekly_trend: z.array(PulseWeekSchema).default([]),
  by_site: z.array(PulseSiteSchema).default([]),
}).passthrough();

export const PulseSurfaceResponseSchema = surfaceEnvelope(PulseSurfaceDataSchema);

export type PulseProject = z.infer<typeof PulseProjectSchema>;
export type PulseWeek = z.infer<typeof PulseWeekSchema>;
export type PulseSite = z.infer<typeof PulseSiteSchema>;
export type PulseSurfaceData = z.infer<typeof PulseSurfaceDataSchema>;
export type PulseSurfaceResponse = z.infer<typeof PulseSurfaceResponseSchema>;
